import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Shield, Wrench, Clock } from "lucide-react";
import { fadeUp, staggerContainerFast } from "@/utils/animations";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/f6a3f174-a193-4e97-9f7a-54fb8e64a616/images/93ce25f58da721f380c5745ae16b786d932b3e82d9e970d243d8da5bfe87cbb2.png";

export default function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Industrial warehouse" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <motion.div initial="hidden" animate="visible" variants={staggerContainerFast} className="max-w-3xl">
          <motion.div variants={fadeUp} className="industrial-line mb-8" />
          <motion.h1
            variants={fadeUp}
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1] mb-6"
            style={{ fontFamily: "'Clash Display', sans-serif" }}
          >
            Industrial Textile Solutions{" "}
            <span className="gradient-text">Built for Performance</span>
          </motion.h1>
          <motion.p variants={fadeUp} className="text-base sm:text-lg text-[#A3A3A3] mb-10 max-w-xl leading-relaxed">
            Custom industrial curtains, PVC walls, and protective textile systems engineered for
            Australia's toughest industrial environments.
          </motion.p>
          <motion.div variants={fadeUp} className="flex flex-wrap gap-4">
            <Link to="/quote" data-testid="hero-quote-btn" className="inline-flex items-center gap-2 bg-[#FF5722] text-white px-8 py-3.5 font-semibold text-sm hover:bg-[#E64A19] transition-colors duration-200 group">
              Request a Quote <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link to="/products" data-testid="hero-products-btn" className="inline-flex items-center gap-2 border border-[#FF5722] text-[#FF5722] px-8 py-3.5 font-semibold text-sm hover:bg-[#FF5722] hover:text-white transition-all duration-200">
              View Products
            </Link>
          </motion.div>
        </motion.div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 bg-[#141414]/90 backdrop-blur-sm border-t border-[#2E2E2E]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-wrap justify-center md:justify-between items-center gap-6 text-sm text-[#A3A3A3]">
          <div className="flex items-center gap-2"><Shield size={16} className="text-[#FF5722]" /><span>Australian Made</span></div>
          <div className="flex items-center gap-2"><Shield size={16} className="text-[#FF5722]" /><span>Commercial Grade Materials</span></div>
          <div className="flex items-center gap-2"><Wrench size={16} className="text-[#FF5722]" /><span>Custom Engineered Solutions</span></div>
          <div className="flex items-center gap-2"><Clock size={16} className="text-[#FF5722]" /><span>Fast Turnaround</span></div>
        </div>
      </div>
    </section>
  );
}
